































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { User, TeamReviewees } from "../../types";

@Component
export default class AutoComplete extends Vue {
  @Prop() private suggestions!: TeamReviewees[];
  @Prop() private selection!: TeamReviewees;
  private selectionText: string = "";
  private isOpen = false;
  private results: TeamReviewees[] = [];
  private arrowCounter = 0;

  @Watch("selection", { immediate: true })
  private onSelectionChange() {
    this.selectionText = this.selection.name;
  }

  private onChange() {
    this.filterResults();
    if (this.results && this.results.length > 0) {
      this.isOpen = true;
    } else {
      this.isOpen = false;
    }
  }

  private filterResults() {
    if (this.suggestions && this.suggestions.length > 0) {
      if (this.selectionText && this.selectionText.length > 0) {
        this.results = this.suggestions.filter(suggestions => {
          return (
            suggestions.name
              .toLowerCase()
              .indexOf(this.selectionText.toLowerCase()) > -1
          );
        });
      } else {
        this.results = this.suggestions.filter(suggestions => {
          return suggestions.name;
        });
      }
    }
  }

  private setResult(result: string, uid: string) {
    this.isOpen = false;
    this.$emit("selection", uid);
  }
  private onArrowDown(evt: any) {
    evt.preventDefault();
    if (this.arrowCounter < this.results.length - 1) {
      this.arrowCounter = this.arrowCounter + 1;
      this.fixScrolling();
    }
  }
  private onArrowUp(evt: any) {
    evt.preventDefault();
    if (this.arrowCounter > 0) {
      this.arrowCounter = this.arrowCounter - 1;
      this.fixScrolling();
    }
  }
  private fixScrolling() {
    const optionsList = this.$refs.options as Element[];
    const liH = optionsList[this.arrowCounter].clientHeight;
    const scrollContainer = this.$refs.scrollContainer as Element;
    scrollContainer.scrollTop = liH * this.arrowCounter;
  }

  private onEnter() {
    if (this.arrowCounter > -1) {
      this.isOpen = false;
      this.$emit("selection", this.results[this.arrowCounter].uid);
      this.arrowCounter = -1;
    }
  }

  private handleClickOutside(evt: any) {
    if (!this.$el.contains(evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
    }
  }
}
